import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setActiveProduct } from "../../Redux/Products/Products.actions";

const useStyles = makeStyles({
  root: {
    maxWidth: "380px",
    marginTop: "25px",
    overflow: "hidden",
    height: "500px",
    boxShadow: "1px 8px 18px -5px rgba(0, 0, 0, 0.7)",
  },
  img: {
    width: "100%",
    height: "300px",
    transform: "scaleX(1.15)",
  },
  buttons: {
    backgroundColor: "#43444d",
    height: "40px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  button: {
    color: "white",
    height: "100%",
  },
  price: {
    fontSize: "18px",
    margin: 0,
  },
  loading: {
    height: "300px",
    width: "100%",
    backgroundColor: "black",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
  },
});

const ProductCard = ({ history, data }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const viewDetails = () => {
    dispatch(setActiveProduct(data));
    history.push(`/product/${data.catagory}/${data._id}`);
  };

  const getPrice = () => {
    if (data.catagory === "beds" || data.catagory === "mattress") {
      return data.others.sizes[0].price;
    }
    if (data.catagory === "furniture") {
      if (data.others.noCustoms) {
        return data.price;
      } else {
        return data.others.sizes[0].price;
      }
    }
  };

  return (
    <Card className={classes.root}>
      <CardActionArea style={{ height: "450px" }} onClick={viewDetails}>
        <CardMedia
          component="img"
          alt="Contemplative Reptile"
          height="140"
          image={data.images[0]}
          title="Contemplative Reptile"
          className={classes.img}
        />
        <CardContent style={{ height: "160px" }}>
          <Typography
            style={{ fontSize: "18px" }}
            gutterBottom
            variant="h5"
            component="h2"
          >
            {data.name}
          </Typography>
          <Typography
            className={classes.price}
            variant="body2"
            color="textSecondary"
            component="p"
          >
            <p>
              &pound;
              {getPrice()}
            </p>
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions className={classes.buttons}>
        <Button onClick={viewDetails} className={classes.button} size="small">
          View Details
        </Button>
      </CardActions>
    </Card>
  );
};

export default withRouter(ProductCard);
